export default __webpack_public_path__ + "static/media/laboratory.a23390f2.jpg";